<template>
    <div>
        <!-- 一步到位 -->
        <Steps
                :title="$t('edit.ruler.ruler')"
                :isShowArrow="true"
                :isLast="true"
                @clickBack="onClickBack"
                @onClickFinish="onClickFinish"
        >
            <template slot="body">
                <div class="edit-module">
                    <div class="ruler-input">
                        <div class="length-tip">
                            <!-- <div
                                    v-for="(item,index) in unitList"
                                    :key="index"
                                    @click="changeUnit(item)"
                                    :class="rulerObj.unit == item?'active':''"
                            >{{item}}</div> -->
                            <a-select :default-value="$t('edit.ruler.meter')" style="width: 110px;" @change="changeUnit">
                                <a-select-option v-for="(item,index) in unitList" :key="index" :value="item">
                                    {{item}}
                                </a-select-option>
                            </a-select>

                        </div>
                        <a-input type="number" :placeholder="$t('edit.ruler.longInput')" v-model="rulerObj.length" @change="changeLength" @blur="onInoutBlur"/>
                    </div>
                    <div class="ruler-input">
                        <!--是否顯示標題-->
                        <div class="show-title">
                            <!-- <van-switch
                                    v-model="switchChecked"
                                    size="26"
                                    active-color="#ce1414"
                                    inactive-color="#323232"
                                    @change="changeShowTitle"
                            /> -->
                            <a-checkbox :checked="rulerObj.is_show_title === 1" @change="changeShowTitle">
                                {{$t('edit.hpInfo.showTitle')}}
                            </a-checkbox>
                        </div>
                        <a-input :placeholder="$t('edit.ruler.nameInput')" v-model="rulerObj.title" @change="changeTitle" @blur="onInoutBlur"/>
                    </div>
                </div>
            </template>
        </Steps>
    </div>
</template>

<script>
    import Steps from "../../Steps.vue";
    import { v4 as uuidv4 } from "uuid";
    export default {
        name: "AddRuler",
        components:{
            Steps
        },
        props:{
            defaultObj:{
                type:Object,
                default: ()=> {}
            }
        },
        data(){
            return{
                rulerObj:{
                    title: '',
                    is_show_title: 1,
                    length: 0,
                    unit: this.$t('edit.ruler.meter'),
                    ruler_id:'',
                    hotspot_mark:{
                        name:"ruler_" + uuidv4(),
                        point:[]
                    },
                    hotspot_desc:{
                        ath:0,
                        atv:0,
                        txt:this.$t('edit.ruler.dragAdjustPosition')
                    }
                },
                kr: null,
                unitList:[
                    this.$t('edit.ruler.meter'),
                    this.$t('edit.ruler.centimeter'),
                    this.$t('edit.ruler.kilometre'),
                    this.$t('edit.ruler.millimeter'),
                    this.$t('edit.ruler.size'),
                    this.$t('edit.ruler.m'),
                    this.$t('edit.ruler.cm'),
                    this.$t('edit.ruler.km'),
                    this.$t('edit.ruler.mm'),

                ],
                switchChecked: true,
                isNewRuler: true
            }
        },
        watch: {
            defaultObj: {
                handler: function (value) {
                    if (value) {
                        this.rulerObj = value;
                        this.isNewRuler = false
                    }
                },
                immediate: true,
                deep: true,
            },
            'rulerObj.is_show_title'(newVal){
                if(newVal == 1){
                    this.updateTxt(true)
                }else{
                    this.updateTxt(false)
                }
            }
        },
        created() {
            this.kr = document.getElementById('krpanoSWFObject');
            this.initRuler()
            this.switchChecked = this.rulerObj.is_show_title == 1? true :false

            /*if(this.rulerObj.hotspot_mark.point.length){
                lookto(this.rulerObj.hotspot_mark.point[0].ath, this.rulerObj.hotspot_mark.point[0].atv);
            }else{
                lookto(-15, 0);
            }*/
        },
        methods:{
            onInoutBlur() {
                window.scrollTo(0, 0);
            },
            //初始化標尺
            initRuler(){
                const mark = {...this.rulerObj.hotspot_mark};
                const desc = {...this.rulerObj.hotspot_desc};
                krMarkLine.init(this.kr,true,mark,desc);
            },
            //刪除當前標尺
            deleteInitRuler(){
                krMarkLine.krpano_obj = this.kr;
                krMarkLine.hotspot_mark.name = this.rulerObj.hotspot_mark.name
                krMarkLine.delete()
            },
            //改變長度
            changeLength(e){
                this.rulerObj.length = parseFloat(e.target.value)
                this.updateTxt(true)
            },
            //改變單位
            changeUnit(e){
                this.rulerObj.unit = e;
                this.updateTxt(true)
            },
            //改變title
            changeTitle(e){
                this.rulerObj.title = e.target.value;
                if(this.rulerObj.is_show_title == 1){
                    this.updateTxt(true)
                }
            },
            //是否顯示名稱
            changeShowTitle(value){
                this.switchChecked = value.target.checked
                this.rulerObj.is_show_title = value.target.checked?1:0
            },
            onClickBack(){
                this.closeSet(false)
                this.$emit("onClickBack");
            },
            //判斷
            closeSet(type){
                this.deleteInitRuler()
                if(!this.isNewRuler || type){
                    const mark = {...this.rulerObj.hotspot_mark};
                    const desc = {...this.rulerObj.hotspot_desc};
                    krMarkLine.init(this.kr,false,mark,desc);
                }
            },
            //保存
            onClickFinish(){
                if(this.rulerObj.title == ''){
                    this.$message.error(this.$t("edit.ruler.titleInput"))
                    return
                }
                let list = krMarkLine.returnData()
                this.rulerObj = {...this.rulerObj,...list}
                this.$set(this.rulerObj,'ruler_id',this.rulerObj.hotspot_mark.name)
                this.closeSet(true)
                this.$emit("saveChangeData",
                    {
                        key: this.rulerObj.hotspot_mark.name,
                        data: this.rulerObj,
                    });
            },
            //修改文字內容
            updateTxt(showTitle){
                if(showTitle){
                    krMarkLine.hotspot_desc.txt = this.rulerObj.title + this.rulerObj.length + this.rulerObj.unit
                }else{
                    krMarkLine.hotspot_desc.txt = this.rulerObj.length + this.rulerObj.unit
                }
                krMarkLine.addTxt()
            },
        }
    }
</script>

<style lang="less" scoped>
.ruler-input{
    margin-bottom: 20px;
    position: relative;
    &:last-child{
        margin-bottom: 0;
    }
    .length-tip{
        position: absolute;
        top: 4px;
        right: 4px;
        color: #CE1414;
        display: flex;
        z-index: 10;
        border-radius: 4px;
        overflow: hidden;
        // .btn-c{
        //     background-color: #CE1414;
        //     border: #CE1414;
        //     color: #ffffff;
        // }
        // div{
        //     height: 32px;
        //     line-height: 32px;
        //     padding: 0 16px;
        //     // background-color: #323232;
        //     color: #666;
        //     &:first-child{
        //         border-right: 1px solid #141414;
        //     }
        //     &.active{
        //         background-color: #CE1414;
        //         color: #ffffff;
        //     }
        // }
    }

    .show-title{
        position: absolute;
        top: 9px;
        right: 4px;
        z-index: 10;
    }
    /deep/ .ant-checkbox-wrapper{
      color: #ffffff;
    }
}
.mob-inject .edit-module {
    overflow: hidden;
    padding:0 16px;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
}
.ant-input{
    height:40px;
    background-color:rgba(0, 0, 0, 0.3);
    color:#ffffff;
}
</style>
